<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Games from "@/services/Games";
    import DatePicker from "vue2-datepicker";
    import "vue2-datepicker/index.css";
    import moment from "moment";

    export default {
        components: { Layout, PageHeader, DatePicker },
        page: {
            title: "Player of the month",
            meta: [{ name: "description", content: appConfig.description }],
        },

        data() {
            return {
                isBusy: false,
                error: null,
                tableData: [],
                endpoint: '',
                title: "Player of the month",
                items: [
                    { text: "Fan Experience" },
                    { text: "Player of the month" },
                ],
                top5Women: [],
                top5Men: [],
                totalRows: 0,
                tableDataWomen: [],
                tableDataMen: [],
                totalRowsWomen: 0,
                totalRowsMen: 0,
                currentPageWomen: 1,
                currentPageMen: 1,
                perPage: 10,
                currentPage: 1,
                pageOptions: [10, 25, 50, 100],
                sortBy: "votes",
                sortDesc: true,
                showLoader: false,
                month: moment().format("YYYY-MM"),
                selectedMatch: null,
                top5Players: [],
                fields: [
                    { key: "first_name", label: "First Name", sortable: true },
                    { key: "last_name", label: "Last Name", sortable: true },
                    { key: "team_name", label: "Team Name", sortable: true },
                    { key: "team_code_overwrite", label: "Team Code", sortable: true },
                    { key: "description", label: "Match", sortable: true },
                    { key: "date_time", label: "Date", sortable: true },
                ],
            };
        },
        watch: {
            month(newMonth) {
                this.totalRows = 0
                this.getMatchesMonthly(newMonth);
                this.top5Players = []
            },
        },
        async mounted() {
            await this.getMatchesMonthly(this.month);
        },
        methods: {
            async getMatchesMonthly(selectedMonth = this.month) {
                this.tableData = []
                this.isBusy = true;
                this.showLoader = false;
                try {
                    this.endpoint = `${selectedMonth}`;
                    let response;
                    response = await Games.getMatchesMonthly(this.endpoint);
                    if (response?.data.data) {
                        this.tableDataWomen = response.data.data.women_team;
                        this.totalRowsWomen = this.tableDataWomen.length;

                        this.tableDataMen = response.data.data.first_team;
                        this.totalRowsMen = this.tableDataMen.length;

                        this.calculateTop5(this.tableDataWomen, 'women');
                        this.calculateTop5(this.tableDataMen, 'men');
                    }

                } catch (error) {
                    this.error = error?.response?.data?.error || "An error occurred while fetching data.";
                } finally {
                    this.isBusy = false;
                    this.showLoader = true;
                }
            },

            handleDatePickerConfirm(selectedDate) {
                if (selectedDate) {
                    this.month = moment(selectedDate).format("YYYY-MM");
                }
            },

            async exportToExcel() {
                try {

                    const response = await Games.exportToExcel(this.month);

                    if (response.data && typeof response.data.data === 'object') {
                        const ExcelJS = require('exceljs');
                        const workbook = new ExcelJS.Workbook();
                        const worksheet = workbook.addWorksheet('Player of the Month');

                        const columnHeaders = [
                            { key: 'first_name', header: 'First Name', width: 20 },
                            { key: 'last_name', header: 'Last Name', width: 20 },
                            { key: 'team_name', header: 'Team Name', width: 20 },
                            { key: 'team_code_overwrite', header: 'Team Code', width: 20 },
                            { key: 'description', header: 'Match', width: 30 },
                            { key: 'date_time', header: 'Date', width: 20 },
                        ];

                        const monthLabel = moment(this.month, 'YYYY-MM').format('MMMM YYYY');

                        // Title
                        worksheet.mergeCells('A1', 'F1');
                        const titleCell = worksheet.getCell('A1');
                        titleCell.value = `Player of the Month – ${monthLabel}`;
                        titleCell.font = { size: 16, bold: true };
                        titleCell.alignment = { vertical: 'middle', horizontal: 'center' };

                        worksheet.addRow([]);

                        const addTeamSection = (teamName, dataArray) => {

                            worksheet.addRow([teamName]);
                            worksheet.getRow(worksheet.lastRow.number).font = { bold: true };

                            worksheet.addRow(columnHeaders.map(col => col.header));
                            worksheet.getRow(worksheet.lastRow.number).font = { bold: true };

                            (dataArray || []).forEach(item => {
                                const rowData = columnHeaders.map(col => item[col.key] || '');
                                worksheet.addRow(rowData);
                            });

                            worksheet.addRow([]); // space after section
                        };

                        addTeamSection('First Team', response.data.data.first_team);
                        addTeamSection('Women Team', response.data.data.women_team);

                        columnHeaders.forEach((column, index) => {
                            worksheet.getColumn(index + 1).width = column.width;
                        });

                        const buffer = await workbook.xlsx.writeBuffer();

                        const blob = new Blob([buffer], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `Player of the Month - ${this.month}.xlsx`;
                        link.click();

                    } else {
                        this.$bvToast.toast('No data available for generating the report.', {
                            title: 'Warning',
                            variant: 'warning',
                            solid: true
                        });
                    }
                } catch (error) {
                    this.$bvToast.toast('An error occurred while exporting data.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                }
            },


            calculateTop5() {
                const playerVotesMap = (players) => {
                    const map = new Map();
                    players.forEach(vote => {
                        const playerId = vote.player_id;
                        if (map.has(playerId)) {
                            map.get(playerId).voteCount += 1;
                        } else {
                            map.set(playerId, {
                                voteCount: 1,
                                firstName: vote.first_name,
                                lastName: vote.last_name,
                                img: vote.img,
                                team_name: vote.team_name,
                                playerId: playerId
                            });
                        }
                    });
                    return Array.from(map.values()).sort((a, b) => b.voteCount - a.voteCount);
                };

                this.top5Women = playerVotesMap(this.tableDataWomen).slice(0, 4);
                this.top5Men = playerVotesMap(this.tableDataMen).slice(0, 4);
            }
        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-4">
                            <div class="col-md-12">
                                <div class="d-flex flex-column flex-md-row align-items-center justify-content-center">
                                    <div class="mb-3 mb-md-0 text-center">
                                        <label class="form-label">Select Month</label>
                                        <div class="input-group" style="width: 250px;">
                                            <date-picker
                                                    v-model="month"
                                                    append-to-body
                                                    lang="en"
                                                    type="month"
                                                    confirm
                                                    format="YYYY-MM"
                                                    value-type="format"
                                                    @confirm="handleDatePickerConfirm"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end mb-3" v-if="showLoader">
                            <b-button
                                    v-if="month"
                                    variant="success"
                                    title="Export to Excel"
                                    @click="exportToExcel()"
                            >
                                Export to Excel
                            </b-button>
                        </div>
                    </div>
                </div>

                <div class="card" v-if="showLoader">
                    <div class="card-body">
                        <h4 class="card-title mb-3">Top 4 Men Players of the Month</h4>
                        <div class="row d-flex justify-content-start">
                            <div class="col-3 text-center" v-for="player in top5Men" :key="player.playerId">
                                <img :src="player.img" :alt="player.firstName + ' ' + player.lastName" height="150" class="rounded shadow">
                                <p class="text-strong mt-2 lead">{{ player.voteCount }} Votes</p>
                                <p class="text-strong font-size-16">{{ player.firstName }} {{ player.lastName }}</p>
                                <p>{{ player.team_name }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-3">Men's Team Votes</h4>
                        <b-table
                                :busy="isBusy"
                                :items="tableDataMen"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPageMen"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                show-empty
                                empty-text="No nominations found for the selected month"
                                class="table-centered"
                                thead-class="table-light"
                                striped
                                hover
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="text-muted">
                                    Showing <b>{{ (currentPageMen - 1) * perPage + 1 }}</b> to
                                    <b>{{ Math.min(currentPageMen * perPage, totalRowsMen) }}</b> of
                                    <b>{{ totalRowsMen }}</b> entries
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination v-model="currentPageMen" :total-rows="totalRowsMen" :per-page="perPage" />
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card" v-if="showLoader">
                    <div class="card-body">
                        <h4 class="card-title mb-3">Top 4 Women Players of the Month</h4>
                        <div class="row d-flex justify-content-start">
                            <div class="col-3 text-center" v-for="player in top5Women" :key="player.playerId">
                                <img :src="player.img" :alt="player.firstName + ' ' + player.lastName" height="150" class="rounded shadow">
                                <p class="text-strong mt-2 lead">{{ player.voteCount }} Votes</p>
                                <p class="text-strong font-size-16">{{ player.firstName }} {{ player.lastName }}</p>
                                <p>{{ player.team_name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Women's team table -->
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-3">Women's Team Votes</h4>
                        <b-table
                                :busy="isBusy"
                                :items="tableDataWomen"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPageWomen"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                show-empty
                                empty-text="No nominations found for the selected month"
                                class="table-centered"
                                thead-class="table-light"
                                striped
                                hover
                        >
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="row mt-3">
                            <div class="col-md-6">
                                <div class="text-muted">
                                    Showing <b>{{ (currentPageWomen - 1) * perPage + 1 }}</b> to
                                    <b>{{ Math.min(currentPageWomen * perPage, totalRowsWomen) }}</b> of
                                    <b>{{ totalRowsWomen }}</b> entries
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <b-pagination v-model="currentPageWomen" :total-rows="totalRowsWomen" :per-page="perPage" />
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
    .card {
        border-radius: 12px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        border: none;
    }

    .card-header {
        background-color: #f8f9fa;
        border-bottom: 1px solid #eaeaea;
    }

    .table-centered td, .table-centered th {
        vertical-align: middle;
    }

    .search-box {
        width: 250px;
    }

    .spinner-grow {
        width: 2rem;
        height: 2rem;
    }

    .input-group-text {
        background-color: #f8f9fa;
    }

    .btn-outline-primary {
        transition: all 0.3s ease;
    }

    .btn-outline-primary:hover {
        transform: translateY(-1px);
    }

    .empty-state {
        padding: 3rem 0;
        text-align: center;
        background-color: #fafbfd;
        border-radius: 8px;
    }

    .mx-datepicker {
        width: 100%;
    }
</style>